import type { IFacebookTargeting } from '@/types/locationTargeting';

export type FacebookLocationRowProblem = 'country' | 'location' | 'radius';

export const FACEBOOK_LOCATION_RADIUS_MIN = 17;
export const FACEBOOK_LOCATION_RADIUS_MAX = 80;

/**
 * Returns which field of a Facebook location row still needs fixing before the row can be saved, or null when the
 * row is complete. Mirrors the server's rules, so an incomplete row never reaches it.
 */
export function facebookLocationRowProblem(
  row: Partial<IFacebookTargeting> | null | undefined
): FacebookLocationRowProblem | null {
  if (!row?.target_country) return 'country';
  if (row.target_type === 'country') return null;
  if (!row.target_type || (!row.target_key && !row.target_name)) return 'location';

  const radius = row.target_radius;
  if (
    row.target_type !== 'region' &&
    radius !== null &&
    radius !== undefined &&
    (radius < FACEBOOK_LOCATION_RADIUS_MIN || radius > FACEBOOK_LOCATION_RADIUS_MAX)
  ) {
    return 'radius';
  }

  return null;
}

/**
 * Whether any of the given Facebook location rows is not ready to be saved.
 */
export function hasFacebookLocationRowProblem(rows: Partial<IFacebookTargeting>[] | null | undefined): boolean {
  return (rows || []).some((row) => facebookLocationRowProblem(row) !== null);
}
